import type { SliceStateFromReducer } from 'shared/types';

import type { analyticsSlice } from './analytics.slice';

type TAnalyticsStore = SliceStateFromReducer<typeof analyticsSlice>;

export const analyticsBaseSelector = (state: TAnalyticsStore) => state.analytics.base;

export const analyticsIdsSelector = (state: TAnalyticsStore) => {
  const utm = state.analytics.base?.utm || {};
  return {
    uaClientId: utm.uaClientId,
    ymClientId: utm.ymClientId,
  };
};

export const analyticsUTMSelector = (state: TAnalyticsStore) => state.analytics.base?.utm;
